import {SxType} from "@baseTypes/sx/sxTypes";
import {BUTTON_SHADOW_SYNC} from "@containers/singleVoyage/voyageTemplates/sync/theme";

export const sx: SxType = {
	root: {
		position: 'relative',
		width: '100%',
		height: '100%',
		// zoom and fullscreen buttons: one size, smaller than the app's 42px, see-through
		'& .leaflet-bar': {
			boxShadow: 'none',
		},
		'& .leaflet-bar a, & .leaflet-touch .leaflet-bar a, & a.leaflet-control-zoom-fullscreen': {
			width: '30px !important',
			height: '30px !important',
			lineHeight: '30px !important',
			fontSize: '18px !important',
			backgroundColor: 'rgba(12, 109, 223, 0.6) !important',
			backgroundSize: '16px 16px !important',
			backdropFilter: 'blur(6px)',
			boxShadow: BUTTON_SHADOW_SYNC,
			borderRadius: '50% !important',
			marginBottom: '6px',
		},
		'& .leaflet-bar a:hover': {
			backgroundColor: 'rgba(12, 109, 223, 0.9) !important',
		},
		// the map style switcher joins the zoom and fullscreen buttons in the bottom right corner
		'& .leaflet-container > .MuiBox-root': {
			top: 'auto !important',
			left: 'auto !important',
			right: '10px',
			bottom: '134px',
			zIndex: 1000,
		},
		'& .leaflet-container > .MuiBox-root button': {
			width: '30px',
			height: '30px',
			padding: '7px !important',
			backgroundColor: 'rgba(12, 109, 223, 0.6) !important',
			backdropFilter: 'blur(6px)',
			boxShadow: BUTTON_SHADOW_SYNC,
			'&:hover': {
				backgroundColor: 'rgba(12, 109, 223, 0.9) !important',
			},
			'& svg': {
				width: '16px',
				height: '16px',
			},
		},
	},
}
